<div class="toast-container">
  @for (toast of toasts(); track toast.id) {
    <div class="toast toast-{{ toast.type }}">
      <mat-icon class="toast-icon">{{ iconFor(toast.type) }}</mat-icon>
      <span class="toast-message">{{ toast.message }}</span>
      <button class="toast-close" (click)="dismiss(toast.id)" aria-label="close">✕</button>
    </div>
  }
</div>
